import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from './rest-service';
import { IImgMediaDto } from 'src/app/core/dtos/interfaces/i-img-media-dto';
import { map } from 'rxjs/operators';
import { ITagCMSApi } from 'src/app/core/models/i-tag';

@Injectable({
  providedIn: 'root',
})
export class ImagesService {
  static readonly ENTITY_IDENTIFIER: string = 'images';
  private readonly BASE_MEDIA_ROUTE = `api/${ImagesService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_MEDIA_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getFiltered$(
    {
      currentPage,
      currentPageSize,
    }: { currentPage: number; currentPageSize: number } = {
      currentPage: 1,
      currentPageSize: 5,
    },
    {
      filters = {},
    }: {
      filters?: { [key: string]: unknown };
    } = {
      filters: {},
    },
    // TODO IMPROVEMENT: Review endpoint structure on media library migation
  ): Observable<{ results: Partial<IImgMediaDto>[]; totalCount: number }> {
    const params = this.restService.buildParamsObjectWithPaging(
      filters,
      currentPage,
      currentPageSize,
    );

    return this.restService.post$<{
      results: Partial<IImgMediaDto>[];
      totalCount: number;
    }>(this.BUILD_HTTP_ROUTE(), filters, {
      params,
    });
  }

  getFilteredTags$(
    {
      currentPage,
      currentPageSize,
    }: { currentPage: number; currentPageSize: number } = {
      currentPage: 1,
      currentPageSize: 5,
    },
    {
      filters = {},
    }: {
      filters?: { [key: string]: unknown };
    } = {
      filters: {},
    },
    // TODO IMPROVEMENT: Review endpoint structure on media library migation, create tags service instead
  ): Observable<ITagCMSApi[]> {
    const params = this.restService.buildParamsObjectWithPaging(
      filters,
      currentPage,
      currentPageSize,
    );

    return this.restService
      .get$<{ matches: ITagCMSApi[] }>(this.BUILD_HTTP_ROUTE('tags'), {
        params,
      })
      .pipe(map((r) => r.matches));
  }
}
